import { PureComponent, type ReactNode } from "react";

export type FAQProps = {
  title?: string;
  sidebar?: boolean;
  children?: ReactNode;
};

export class FAQ extends PureComponent<FAQProps> {
  render(): ReactNode {
    return (
      <div className={`mb-5 ${this.props.sidebar ? "bg-white text-sm py-1 rounded shadow" : ""}`}>
        <div
          className={`${this.props.sidebar ? "py-3 px-5 md:p-3 font-semibold" : "font-serif text-2xl mb-5"}`}
        >
          {this.props.title ? this.props.title : "Häufige Fragen"}
        </div>
        <div>{this.props.children}</div>
      </div>
    );
  }
}
